import { useQuery } from '@tanstack/react-query';

import InclusionsService from '~/services/InclusionsService';

import { inclusionsQueryKeys } from './inclusionsQueryKeys';

const ALL_INCLUSIONS_PAGE_SIZE = 500;

export interface VendorInclusion {
  id: string;
  name: string;
  type: string;
  category?: {
    name: string;
  };
}

interface UseGetVendorInclusionsParams {
  vendorId: string;
  offerId: string;
  enabled?: boolean;
}

export function useGetVendorInclusions({ vendorId, offerId, enabled = true }: UseGetVendorInclusionsParams) {
  return useQuery<Array<VendorInclusion>>({
    queryKey: inclusionsQueryKeys.vendorInclusions(vendorId, offerId),
    queryFn: async () => {
      const response = await InclusionsService.getInclusions(
        vendorId,
        offerId,
        { page: 0, pageSize: ALL_INCLUSIONS_PAGE_SIZE },
        undefined,
        undefined,
      );
      return response.result ?? [];
    },
    enabled: enabled && !!vendorId && !!offerId,
  });
}
